import script from "./SideArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./SideArticle.vue?vue&type=script&setup=true&lang=js"

import "./SideArticle.vue?vue&type=style&index=0&id=4ba5047a&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba5047a"]])

export default __exports__